const clientVenueAssets = {
  favicon: 'https://assets.clientvenue.com/other/clientvenue-icon.png',
  smallLogo: '',
  smallLogoForLightBg:
    'https://assets.clientvenue.com/other/clientvenue-icon.png',
  largeLogo: 'https://assets.clientvenue.com/other/clientvenue-logo.png',
  brandName: 'ClientVenue'
}

export default clientVenueAssets
